import { Dialog } from '@mui/material';

import { GDMDialogComponent } from './GDMDialog.type';

/* TODO: Implement component using GDM default design */
const GDMDialog: GDMDialogComponent = props => <Dialog {...props} />;

export default GDMDialog;
